import { useNavigate, useParams } from "react-router-dom";
import PageContainer from "../../components/PageContainer/PageContainer";
import Header from "../../components/atoms/Header";
import { ROUTES } from "../../config/nav";
import { ReactNode } from "react";
import useRoleUser from "../../hooks/auth/useRoleUser";
import DetailVehicleComponent from "../../components/vehicle/DetailVehicleComponent";

type Props = {};

export type TDetailMap = {
  label: string;
  value: ReactNode;
};

const DetailSafetyChecklistVehiclePage = (_: Props) => {
  const navigate = useNavigate();
  const role = useRoleUser();
  const { id: vehicleId } = useParams<"id">();

  return (
    <>
      {
        <PageContainer
          headerNavigationContent={
            <Header
              backButtonOnClick={() => {
                navigate(
                  `${role && role === "FSO" ? ROUTES.admin : ROUTES.guest}`
                );
              }}
              showBackButton={true}
              title={`Data Kendaraan`}
            />
          }
          withBackground
          mainContainerStyle={{
            padding: "16px 0 72px 0",
            minHeight: "100vh",
          }}
        >
          <DetailVehicleComponent
            vehicleId={vehicleId}
            isShowFloatingButton
            isShowLastSafetyCheckButton={true}
          />
        </PageContainer>
      }
    </>
  );
};

export default DetailSafetyChecklistVehiclePage;
